import script from "./AddressConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressConfig.vue?vue&type=script&lang=ts&setup=true"

import "./AddressConfig.vue?vue&type=style&index=0&id=c2ab7ca8&lang=scss"
import "./AddressConfig.vue?vue&type=style&index=1&id=c2ab7ca8&lang=scss"
import "./AddressConfig.vue?vue&type=style&index=2&id=c2ab7ca8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ab7ca8"]])

export default __exports__